@import (reference) '../../constants/spacing.module.less';

.rate-viewer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--light--background-color--1);
  border-bottom: solid 1px var(--default--border-color--10);
  padding: @space-16;
}

.header-text-container {
  display: flex;
  align-items: center;
  gap: @space-16;
}

.sort-by-container {
  display: flex;
  align-items: center;
  gap: @space-8;
}
